import React from "react";
import styled from "@emotion/styled";
import { TeamItem } from "./TeamItem";

import andrewJacksonImage from "../../../images/team/andrew-jackson.png";

interface TeamMember {
  image: string;
  name: string;
  title: string;
  description: string;
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const Content = styled.div`
  width: 50%;
`;

const teamMembers: TeamMember[] = [
  {
    image: andrewJacksonImage,
    name: "Andrew L Jackson",
    title: "Founder & CEO",
    description: `"My vision for Hightail Games is to create healthy games that people genuinely enjoy."
    Andrew has worked in the games industry as a programmer for a number of years
    and worked on games ranging from MMORPGs to Action RPGs (all of them multiplayer).
    He's also worked at multiple tech companies that aren't related to gaming.`,
  },
];

export const Team: React.FC = (props) => {
  return (
    <Container>
      <Content>
        {teamMembers.map((member) => (
          <TeamItem {...member} />
        ))}
      </Content>
    </Container>
  );
};
